export const openInNewTab = (src: string, download?: boolean, fileName?: string) => {
  if (!document) return;

  const hasExplicitScheme = /^[a-z][a-z0-9+.-]*:/i.test(src);
  const isProtocolRelative = /^\/\//.test(src);
  const normalizedSrc = (hasExplicitScheme || isProtocolRelative) ? src : `https://${src}`;

  const a = document.createElement('a');
  a.setAttribute('target', '_blank');
  a.setAttribute('rel', 'noreferrer noopenner');
  a.setAttribute('href', normalizedSrc);
  if (fileName) a.setAttribute('download', fileName);

  a.click();
  if (download) window.focus();

  a.remove();
};
